module.exports = __webpack_public_path__ + "new-viabill.38200045a603763caf4e59972e4b2805.png";